import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { retrieve, reset } from '../../actions/Candidate/show';
import { del } from '../../actions/Candidate/delete';
import Moment from 'react-moment';
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import {handleSwitchUser} from "../SwitchUser/SwitchUser";
import IsGranted from "../IsGranted";
import ProfessionMappingView from "../../views/Components/ProfessionMappingView";
import {currentUserHasRole} from "../../utils/auth";
import {renderLinks} from "../../utils/entityList";
import FlashMessages from "../../views/Components/FlashMessages";
import PhoneNumber from "../../views/Components/PhoneNumber";

class CandidateShow extends Component {
  static propTypes = {
    retrieved: PropTypes.object,
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string,
    eventSource: PropTypes.instanceOf(EventSource),
    retrieve: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    deleteError: PropTypes.string,
    deleteLoading: PropTypes.bool.isRequired,
    deleted: PropTypes.object,
    del: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.props.retrieve(decodeURIComponent(this.props.match.params.id));
  }

  componentWillUnmount() {
    this.props.reset(this.props.eventSource);
  }

  del = () => {
    if (window.confirm('Are you sure you want to delete this item?'))
      this.props.del(this.props.retrieved);
  };

  render() {
    if (this.props.deleted)
      this.props.history.push({
        pathname: `..`,
        state: {successMessage: 'Candidate successfully deleted.'}
      });

    const item = this.props.retrieved;

    return (
      <div>
        <h1>Show &quot;{item && item['firstName']} {item && item['lastName']}&quot;</h1>

        <FlashMessages location={this.props.location} />
        {this.props.loading && (
          <div className="alert alert-info" role="status">
            Loading...
          </div>
        )}
        {this.props.error && (
          <div className="alert alert-danger" role="alert">
            <span className="fa fa-exclamation-triangle" aria-hidden="true" />{' '}
            {this.props.error}
          </div>
        )}
        {this.props.deleteError && (
          <div className="alert alert-danger" role="alert">
            <span className="fa fa-exclamation-triangle" aria-hidden="true" />{' '}
            {this.props.deleteError}
          </div>
        )}

        <div className="grid-buttons">
          <Link to=".." className="btn btn-primary">
            Back to list
          </Link>
          {item && (
            <IsGranted action='edit' object={item}>
              <Link to={`../edit/${encodeURIComponent(item['@id'])}`} className="btn btn-warning">Edit</Link>
            </IsGranted>
          )}
          {item && (
            <IsGranted action="impersonate" object={item}>
              <button className="btn btn-info" onClick={() => handleSwitchUser(item['id'])}>Impersonate</button>
            </IsGranted>
          )}
          {item && (
            <IsGranted action="delete" object={item}>
              <button onClick={this.del} className="btn btn-danger">
                Delete
          </button>
            </IsGranted>
          )}
        </div>

        {item && (
          <div style={{'overflowX': 'auto'}}>
            <Table className="table table-responsive table-striped table-hover">
              <TableHead>
                <TableRow>
                  <TableCell>Field</TableCell>
                  <TableCell>Value</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentUserHasRole('ROLE_SUPER_ADMIN') && (
                  <TableRow>
                    <TableCell scope="row">Partner</TableCell>
                    <TableCell>{renderLinks('../partners', item['partner'])}</TableCell>
                  </TableRow>
                )}
                <TableRow>
                  <TableCell scope="row">First Name</TableCell>
                  <TableCell>{item['firstName']}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell scope="row">Last Name</TableCell>
                  <TableCell>{item['lastName']}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell scope="row">Email</TableCell>
                  <TableCell>{item['email']}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell scope="row">Mobile Number</TableCell>
                  <TableCell>
                    <PhoneNumber phone={item['phoneNumber']} formattedPhone={item['formattedPhoneNumber']} />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell scope="row">Profession Mapping</TableCell>
                  <TableCell>
                    {item.professionMappings && item.professionMappings.length > 0 && item.professionMappings.map(
                      (mapping, index) => <ProfessionMappingView key={index} mapping={mapping}/>
                    )}
                    {!item.professionMappings || item.professionMappings.length === 0 && ('-')}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell scope="row">Resume</TableCell>
                  <TableCell>
                    {item['resume'] ? (
                      <a href={item['resume']['file']['url']}>{item['resume']['file']['fileName']}</a>
                    ) : ('-')}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell scope="row">Status</TableCell>
                  <TableCell>{item['status']}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell scope="row">Created At</TableCell>
                  <TableCell>{item['createdAt'] && (<Moment>{item['createdAt']}</Moment>)}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell scope="row">Updated At</TableCell>
                  <TableCell>{item['updatedAt'] && (<Moment>{item['updatedAt']}</Moment>)}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        )}
      </div>
    );
  }

  renderLinks = (type, items) => {
    if (Array.isArray(items)) {
      return items.map((item, i) => (
        <div key={i}>{this.renderLinks(type, item)}</div>
      ));
    }

    return (
      <Link to={`../${type}/show/${encodeURIComponent(items)}`}>{items}</Link>
    );
  };
}

const mapStateToProps = state => ({
  retrieved: state.candidate.show.retrieved,
  error: state.candidate.show.error,
  loading: state.candidate.show.loading,
  eventSource: state.candidate.show.eventSource,
  deleteError: state.candidate.del.error,
  deleteLoading: state.candidate.del.loading,
  deleted: state.candidate.del.deleted
});

const mapDispatchToProps = dispatch => ({
  retrieve: id => dispatch(retrieve(id)),
  del: item => dispatch(del(item)),
  reset: eventSource => dispatch(reset(eventSource))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CandidateShow);
